import { createContext, useContext } from 'react';
export var CheckoutStep;
(function (CheckoutStep) {
    CheckoutStep[CheckoutStep["DETAILS"] = 1] = "DETAILS";
    CheckoutStep[CheckoutStep["DELIVERY"] = 2] = "DELIVERY";
    CheckoutStep[CheckoutStep["PAYMENT"] = 3] = "PAYMENT";
    CheckoutStep[CheckoutStep["CONFIRMATION"] = 4] = "CONFIRMATION";
    CheckoutStep[CheckoutStep["FAST_CHECKOUT"] = 5] = "FAST_CHECKOUT";
})(CheckoutStep || (CheckoutStep = {}));
const defaultState = {
    step: CheckoutStep.DETAILS,
};
export const CheckoutStepContext = createContext(defaultState);
export const useCheckoutStepState = () => useContext(CheckoutStepContext);
